import { AlertDialogBody, AlertDialogFooter } from '@chakra-ui/react'

import { BasicAlertDialog, Button } from '@/components/ui'

interface ExitGridTestingConfirmDialogIProps {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const ExitGridTestingConfirmDialog = ({
  isOpen,
  onCancel,
  onConfirm,
}: ExitGridTestingConfirmDialogIProps) => (
  <BasicAlertDialog
    isCentered
    isOpen={isOpen}
    onClose={onCancel}
    title='Exit Grid Testing Zone?'
  >
    <AlertDialogBody>
      Your test progress will be lost. Are you sure you want to exit?
    </AlertDialogBody>
    <AlertDialogFooter>
      <Button mr={3} onClick={onCancel} variant='secondary'>
        Cancel
      </Button>
      <Button onClick={onConfirm} variant='danger'>
        Exit Test
      </Button>
    </AlertDialogFooter>
  </BasicAlertDialog>
)
